import {mapMutations, mapGetters} from "vuex";

export default {
    name: "password-success",
    data() {
        return {}
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpNewPassword: 'auth/CHANGE_POPUP_PASSWORD_SUCCESS',

        }),
        loginUser() {
            this.changeShowPopUpLogin(true)
            this.changeShowPopUpNewPassword(false)
        }


    },
    computed: {
        ...mapGetters({
            showPopUpNewPasswordSuccess: 'auth/showPopUpNewPasswordSuccess',
        }),
    }
}

